(function(root){
	if (!root) return;
	if (typeof root.process === 'undefined') {
		root.process = { env: { NODE_ENV: 'production' }, nextTick: function(cb){ return setTimeout(cb,0); } };
	}
})(typeof window !== 'undefined' ? window : this);

export {};
